import { useMutation, useQueryClient } from 'react-query'

import { poPdfCustomFieldDisplayQueryConfig } from '@webapp/modules/purchasing/query-configs/poPdfCustomFieldDisplay'
// eslint-disable-next-line import/no-internal-modules
import { SystemPreferencesRepository } from '@webapp/platform/iam/data-access/repositories/SystemPreferencesRepository'
// eslint-disable-next-line import/no-internal-modules
import { systemPreferencesKeys } from '@webapp/platform/iam/data-access/repositories/SystemPreferencesRepository/queryKey.factory'
// eslint-disable-next-line import/no-internal-modules
import { SystemPreferenceKeys } from '@webapp/platform/iam/entities/enums/SystemPreferenceKeys'
// eslint-disable-next-line import/no-internal-modules
import { type POPDFHiddenCustomField } from '@webapp/platform/iam/entities/SystemPreference'

export const useMutatePOPDFHiddenCustomFields = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    // The save contract is the FULL hidden map — the caller rebuilds it from
    // both tables with the toggled entry patched (BHV-045)
    mutationFn: (hiddenMap: POPDFHiddenCustomField[]) =>
      SystemPreferencesRepository.updateSystemPreference(
        SystemPreferenceKeys.PO_PDF_CUSTOM_FIELDS_HIDDEN,
        hiddenMap
      ),
    // Returned so mutateAsync resolves only after the display query has
    // reconciled — lets the Feature Set drop its optimistic override without
    // a flash of stale data
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries(systemPreferencesKeys.all),
        queryClient.invalidateQueries(
          poPdfCustomFieldDisplayQueryConfig.display().queryKey
        ),
      ]),
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  }
}
